import { PALETTE } from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";

const blue = '#13223b';

export default MediaQueryStyleSheet.create({
  root: {
    flex: 1,
    marginLeft:200,
    marginRight:200,
    backgroundColor: PALETTE.loginBg
  },
  rootSearch: {
    flex: 1
  },
  label: {
    color: PALETTE.secondaryText,
    fontSize: 18
  },
  headingRow: {
    paddingLeft:15,
    marginBottom:5,
    marginTop:10,
    marginLeft: 10,
    marginRight: 10
  },
  setCloseIcon: {
    flex:1
  },
  paymentErrorText:{
    flex:0.5
  },
  crossMark: {
    alignSelf: 'flex-end',
  },
  searchBox: {
    height: 40,
    paddingHorizontal: 30,
    top: -35,
    left:0,
    right: 700,
    backgroundColor: PALETTE.loginBg
  },
  row:{
    backgroundColor: blue,
    marginBottom:10,
    paddingLeft:13,
    paddingTop:13,
    paddingBottom:13,
    marginLeft: 10,
    marginRight: 10,
    borderLeftColor: 'white',
    borderLeftWidth: 2
  },
  searchIconStyle: {
    right: 15,
    top: -30,
    position: 'absolute'
  },
  activityLoader:{
    flex:1,
    justifyContent:'center',
    alignSelf:'center'
  },
  errWrapper:{
    flex:1,
    flexDirection:'column',
    justifyContent:'center',
    marginTop:-100
  },
  errroot: {
    backgroundColor:blue,
    marginLeft:10,
    marginRight:10
  },
   closeContainer: {
    height: 50,
    width: 50,
    marginLeft: 10,
    marginTop: 10,
    right: 0,
    top: 0,
    position: 'absolute'
  },
  headline: {
    textAlign: 'center',
    // justifyContent: 'space-around',
    alignItems: 'center',
    marginVertical: 20
  },
});

export const activeSVGStyles = {
  color: PALETTE.primaryText,
};

export const inactiveSVGStyles = {
  color: 'rgba(255, 255, 255, 0.4)', // TODO palettise
};
export const centerSpinner = {
  flex: 1,
  justifyContent: 'space-around',
  alignItems: 'center',
};
export const scrollBarStyle = {
height: '500px',
overflow: 'auto',
};

export const searchIconStyle = {
    paddingLeft:5
  };

  export const modalstyle ={
    flex:1
  };